module.exports = __webpack_public_path__ + "img/Cyprus.b9f4a2d4.gif";